import React, { useEffect, useRef } from 'react';
import { FaPhone, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { motion, useAnimation } from 'framer-motion';

const Footer = () => {
  const sectionRef = useRef(null);
  const controls = useAnimation();

  useEffect(() => {
    const handleAnimation = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          controls.start({
            opacity: 1,
            transition: { duration: 0.5 },
            boxShadow: [
              '0px 0px 0px rgba(255, 255, 255, 0)',
              '0px 0px 8px rgba(255, 255, 255, 1)',
              '0px 0px 16px rgba(255, 255, 255, 0)',
            ],
            y: 0
          });
        } else {
          controls.start({ opacity: 0, boxShadow: '0px 0px 0px rgba(255, 255, 255, 0)' });
        }
      });
    };

    const observer = new IntersectionObserver(handleAnimation, {
      threshold: 0.5,
    });

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [controls]);

  return (
    <div className="container mx-auto shadow-lg rounded-md p-8">
      <section ref={sectionRef} className="py-12 rounded-md" style={{ backgroundColor: '#393E46', color: 'white' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-6">
          <div className="flex flex-col md:flex-row items-center justify-center md:justify-between px-4">
            <p className="text-white text-sm text-center md:text-left mb-4 md:mb-0">
              &copy; 2024 All rights reserved by Umer Javed
            </p>
            <div className="flex flex-col md:flex-row items-center mt-4 md:mt-0">
              <motion.div
                className="flex items-center mx-4 rounded-full mb-4 md:mb-0"
                initial={{ opacity: 0, y: 20, boxShadow: '0px 0px 0px rgba(255, 255, 255, 0)' }}
                animate={controls}
              >
                <FaPhone className="text-white mr-2" />
                <span className="text-sm text-white">+92 (316) 547-2311</span>
              </motion.div>
              <motion.div
                className="flex items-center mx-4 rounded-full mb-4 md:mb-0"
                initial={{ opacity: 0, y: 20, boxShadow: '0px 0px 0px rgba(255, 255, 255, 0)' }}
                animate={controls}
              >
                <FaEnvelope className="text-white mr-2" />
                <span className="text-sm text-white">umerjutt7894@gmail.com</span>
              </motion.div>
              <motion.div
                className="flex items-center mx-4 rounded-full"
                initial={{ opacity: 0, y: 20, boxShadow: '0px 0px 0px rgba(255, 255, 255, 0)' }}
                animate={controls}
              >
                <FaWhatsapp className="text-white mr-2" />
                <span className="text-sm text-white">+92 (316) 547-2311</span>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
